import { useQuery } from "@tanstack/react-query";
import { authService } from "@/services/auth";
import type { OnboardingStatus } from "@/types/user.types";
import { useAuthStore } from "@/store/use-auth-store";

export const useOnboardingStatus = () => {
  const { isAuthenticated } = useAuthStore();
  
  return useQuery<OnboardingStatus>({
    queryKey: ["onboardingStatus"],
    queryFn: () => authService.getOnboardingStatus(),
    enabled: isAuthenticated, // Only run when user is authenticated
    retry: false,
    refetchOnWindowFocus: false, // Prevent refetch on window focus to avoid loops
  });
};

